// extracted by mini-css-extract-plugin
export default {"item":"environment-create_item__z14YW"};